import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { AppConsts } from '@shared/AppConsts';

@Injectable()
export class CustomHeaderInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    var value = abp.utils.getCookieValue(AppConsts.CultureNameKey);

    if (value && value.length) {
      const authReq = req.clone({
        headers: req.headers.set(AppConsts.CustomHeaderForNginxCulture, value)
      });
      return next.handle(authReq);
    } else {
      return next.handle(req);
    }
  }
}